const base_classname = 'ui-search-range-filter';

export const namespace = {
  base: base_classname,
  container: `${base_classname}__container`,
  container_mobile: `${base_classname}__container-mobile`,
  content: `${base_classname}__content`,
  separator: `${base_classname}__separator`,
  actionBtn: `${base_classname}__action-btn`,
  hiddenInput: 'search-hidden-input',
  shops: {
    base: 'shops__price-filter',
    container: 'shops__price-filter-container',
  },
  formControl: 'andes-form-control',
};

export const test_id = 'ui-search-range-filter__text-submit-test';
export const onlyNumbersPattern = '^[0-9]+([,.][0-9]+)?$';
export const type_range = {
  dropdown: 'dropdown',
  range: 'range',
  input: 'input',
  text: 'text',
};
export const id_chevron_icon = 'chevron';

export const RangeFilterItemDefaultProps = {
  defaultClassName: '',
  defaultType: type_range.range,
  defaultValues: [],
  defaultPattern: '',
};
